"use strict";

import axios from "axios";

const actions = {
  async fetchDuplicates({ commit }, responseId) {
    const duplicates = await axios.get(`/1.0/spec-private/sportmaster/duplicates/${responseId}`);
  }
};

const state = function() {
  return {
    duplicates: []
  };
};

export default {
  namespaced: true,
  state,
  actions
};
